/* mt-scripts.js — interactividad propia. Vanilla JS, sin librerías.
   Cada init comprueba si su elemento existe, así el archivo sirve en todas las páginas. */
(function () {
  'use strict';

  /* Este archivo se incluye desde varias secciones: evita ejecutarlo más de una vez
     (si no, se añaden listeners duplicados y, por ejemplo, el acordeón abre y cierra a la vez). */
  if (window.__mtScriptsLoaded) return;
  window.__mtScriptsLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal al hacer scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---- FAQ: usa <details>/<summary> nativo, no necesita JS ---- */

  /* ---- Contador animado ---- */
  function initCount() {
    var nums = document.querySelectorAll('[data-mt-count]');
    if (!nums.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-mt-count'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        obs.unobserve(el);
        var target = parseFloat(el.getAttribute('data-mt-count')) || 0;
        var suffix = el.getAttribute('data-mt-suffix') || '';
        var dur = 1400, start = performance.now();
        function tick(now) {
          var p = Math.min((now - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased).toLocaleString(document.documentElement.lang || 'es-ES') + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { obs.observe(n); });
  }

  /* ---- Página de producto: galería + variantes ---- */
  function initPdp() {
    var root = document.querySelector('[data-mt-pdp]');
    if (!root) return;

    // Galería
    var main = root.querySelector('[data-mt-main-img]');
    var thumbs = root.querySelectorAll('[data-mt-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (main && full) main.src = full;
        thumbs.forEach(function (x) { x.classList.remove('mt-active'); });
        t.classList.add('mt-active');
      });
    });

    // Variantes
    var dataEl = root.querySelector('[data-mt-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selected = {};
    root.querySelectorAll('[data-mt-opt]').forEach(function (group) {
      var name = group.getAttribute('data-mt-opt');
      var first = group.querySelector('.mt-opt__btn.mt-active') || group.querySelector('.mt-opt__btn');
      if (first) selected[name] = first.getAttribute('data-value');
      group.querySelectorAll('.mt-opt__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.mt-opt__btn').forEach(function (b) { b.classList.remove('mt-active'); });
          btn.classList.add('mt-active');
          selected[name] = btn.getAttribute('data-value');
          sync();
        });
      });
    });

    var idInput = root.querySelector('[data-mt-variant-id]');
    var priceEl = root.querySelector('[data-mt-price]');
    var saveEl = root.querySelector('[data-mt-save]');
    var addBtn = root.querySelector('[data-mt-add]');

    function sync() {
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) {
          var oname = dataEl.getAttribute('data-opt-' + (i + 1));
          return selected[oname] === opt;
        });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        var html = '';
        if (match.compare_money) {
          html += '<s>' + match.compare_money + '</s> ';
        }
        html += match.price_money;
        priceEl.innerHTML = html;
      }
      if (saveEl) {
        if (match.save_money) {
          saveEl.textContent = (saveEl.getAttribute('data-mt-save-label') || 'Ahorras') + ' ' + match.save_money;
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
      if (addBtn) {
        if (match.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-label') || 'Añadir al carrito';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-label-soldout') || 'Agotado';
        }
      }
    }
    sync();
  }

  function boot() {
    initReveal();
    initCount();
    initPdp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
